import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { IHelpGuideSummary } from '@apis/help';
import { GuideCardHeader, GuideCardMeta } from './GuideCardParts';
import styles from './HelpCenterPage.module.css';

const MAX_CHIPS = 4;

interface IGuideCardProps {
  guide: IHelpGuideSummary;
  order: number;
}

export function GuideCard({ guide, order }: IGuideCardProps) {
  const { t } = useTranslation();
  const chips = guide.sectionTitles.filter((title) => !/at a glance/i.test(title));
  return (
    <Link to={`/help/${guide.slug}`} className={styles.card} style={{ order }} data-testid="guide-card">
      <GuideCardHeader guide={guide} />
      <p className={styles.cardSummary}>{guide.summary}</p>
      <div className={styles.chips}>
        {chips.slice(0, MAX_CHIPS).map((chip) => <span key={chip}>{chip.replace(/^\d+\.\s*/, '')}</span>)}
        {chips.length > MAX_CHIPS ? <span>+{chips.length - MAX_CHIPS}</span> : null}
      </div>
      <GuideCardMeta
        first={t('help.minRead', { count: guide.minutes })}
        second={t('help.sections', { count: guide.sectionCount })}
        updatedAt={guide.updatedAt}
      />
    </Link>
  );
}
